export const wishlist = {
	data () {
		return {
			wishlist: [],
			wishlistMode: null
			// chosenRecipes: []
		}
	},

	computed: {
		$_wishlist_wishlistRecipes () {
			if (!this.menu) return
			if (!this.wishlist) return
			return this.menu.recipes.filter(recipe => this.wishlist.map(r => +r).includes(recipe.id))
		},

		$_wishlist_wishlistLink () {
			if (!this.wishlist || this.wishlist.length <= 0) return
			return process.env.VUE_APP_BASE_URL + '/wishlist/?chosen_recipes=' + this.wishlist.join(',')
		},

		$_wishlist_billLink () {
			if (!this.recipes || this.recipes.length <= 0) return
			return process.env.VUE_APP_BASE_URL + '/wishlist/?chosen_recipes=' + this.recipes.join(',')
		}
	},
	methods: {
		$_wishlist_isOnWishlist (item) {
			return !!this.wishlist.find(r => +r === item.id)
		},

		$_wishlist_action (item) {
			this.wishlistMode = 'creating_wishlist'
			if (this.$_wishlist_isOnWishlist(item)) {
				this.$_wishlist_remove(item)
			} else {
				this.$_wishlist_add(item)
			}

			var element = document.body
        	element.setAttribute('data-wishlist-widget', this.$_wishlist_wishlistRecipes && this.$_wishlist_wishlistRecipes.length > 0)
			
			var store = window.sessionStorage
			store.setItem('chosen_recipes', this.wishlist.join(','))
		},

		$_wishlist_add (item) {
			this.wishlist.push(item.id)
		},

		$_wishlist_remove (item) {
			var index = this.wishlist.findIndex(r => +r === +item.id)
			this.wishlist.splice(index, 1)
		},

		$_wishlist_getChosenRecipes () {
			var store = window.sessionStorage
			if (store.getItem('chosen_recipes')) {
				this.wishlist = store.getItem('chosen_recipes').split(',', 5)
				this.wishlistMode = 'recieved_recipes'
			}
		}
	},

	mounted () {
		this.$_wishlist_getChosenRecipes()
	}
}
